import initializeComponent from 'Shared/react-initialize';
import Header from './header';
import { initializeNotificationsService } from 'Shared/Notifications/notification_service';
import { withBreakpointsContext } from 'core-components';

initializeNotificationsService();

initializeComponent('Header', withBreakpointsContext(Header));
